  $(document).ready(function(){
    var trigger = $(".custom-bis-trigger");
    if(trigger.length != 0)
    {
      trigger.on("click",function(){
        $(".bis-popup").show();
        $(".bis-alert-danger").hide();
        $(".bis-submit-container").show();
        $(".bis-alert-success").hide();
      });
      
      $(".bis-close").on("click",function(){
        $(".bis-popup").hide();
        $(".bis-submit-container").show();
        $(".bis-alert-success").hide();
        $(".bis-alert-danger").hide();
      });
      if($(".bisselectpicker option").length == 0 )
      {
        $(".bisselectpicker").hide();
        $(".bis-set1").hide()
      }
      if($(".bisselectpicker1 option").length == 0 )
      {
        $(".bisselectpicker1").hide();
        $(".bis-set2").hide();
      }
      $(".bis-submit-container button").on("click",function(e){
        e.preventDefault();
        var email = $("#email").val();
        var productID = $(".bis-popup #product").val();
        var variantID = $(".bisselectpicker").val();
        var product1ID = $(".bis-popup #product1").val();
        var variant1ID = $(".bisselectpicker1").val();
        var key = 'UhYkKj';
        var list = 'RG4RGV';
        var sub = true;
        if(!$("#bis-subscribe_for_newsletter").is(":checked"))
        {
          list = 'UjYbF2';
          sub = false;
        }
        var platform = 'shopify';

        if(isEmail(email))
        {
          if(variantID != null || variantID != undefined)
          {
            $.ajax({
                type: "POST",
                url: "https://a.klaviyo.com/client/back-in-stock-subscriptions",
                headers: {
                  "revision": "2024-06-15",
                  "Content-Type": "application/json"
                },
                data: JSON.stringify({
                  data: {
                    type: "back-in-stock-subscription",
                    attributes: {
                      company_id: "UhYkKj",
                      profile: {
                        data: {
                          type: "profile",
                          attributes: {
                            email: email
                          }
                        }
                      },
                      channels: ["EMAIL"]
                    },
                    relationships: {
                      variant: {
                        data: {
                          type: "catalog-variant",
                          id: `$shopify:::$default:::${variantID}`
                        }
                      }
                    }
                  }
                }),
                success: function(response) {
                  if(variant1ID != null || variant1ID != undefined) {
                    setTimeout(function(){
                      $.ajax({
                        type: "POST",
                        url: "https://a.klaviyo.com/client/back-in-stock-subscriptions",
                        headers: {
                          "revision": "2024-06-15",
                          "Content-Type": "application/json"
                        },
                        data: JSON.stringify({
                          data: {
                            type: "back-in-stock-subscription",
                            attributes: {
                              company_id: "UhYkKj",
                              profile: {
                                data: {
                                  type: "profile",
                                  attributes: {
                                    email: email
                                  }
                                }
                              },
                              channels: ["EMAIL"]
                            },
                            relationships: {
                              variant: {
                                data: {
                                  type: "catalog-variant",
                                  id: `$shopify:::$default:::${variant1ID}`
                                }
                              }
                            }
                          }
                        }),
                        success: function(response) {
                          $(".bis-submit-container").hide();
                          $(".bis-alert-success").show();
                          $(".bis-alert-danger").hide();
                        }
                      });
                    }, 1000);
                  } else {
                    $(".bis-submit-container").hide();
                    $(".bis-alert-success").show();
                    $(".bis-alert-danger").hide();
                  }
                },
                error: function(xhr, status, error) {
                    $(".bis-alert-danger").show();
                }
            });
          }
        }
        else
        {
          $(".bis-alert-danger").show();
        }
      });
      
      function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
      }
    }
  });
